/* Millimili 3.3 — Shopify Inbox "Chat" düğmesi mobilde yolu açar (D34).
   Düğme Inbox uygulamasının <shopify-chat> bileşeninde, part="activator" (açık shadow root; sohbet bir kez açılınca
   Inbox onu iç içe ikinci bir kökte — shopify-agent-runtime — yeniden çizer, betik ikisini de izler). Uygulamanın
   ayarlarına dokunulmaz; yalnız düğmeyi taşıyan kutuya küçük bir stil eklenir. Yalnız dar / dokunmatik ekranda:
   - Aşağı kaydırırken sağa kayıp gizlenir; kaydırma durunca ya da yukarı kaydırınca geri gelir.
   - Durduğu yerde ürün başlığı, fiyat, düğme, link, form alanı gibi bir öğenin üstüne düşecekse en yakın boş yere
     kayar (ör. sabit "Add to bag" çubuğunun üstüne; en çok 200 px yukarı, 12 px aşağı); yakında boş yer yoksa gizli kalır.
   - Çekmece / menü / arama açıkken ve yazı alanı odaktayken (klavye) gizlenir.
   - Sohbet penceresi açıkken hiçbir şey yapmaz. Masaüstünde (≥1200 ve fare) Inbox'ın kendi davranışı aynen kalır. */
(() => {
  const MQ = window.matchMedia('(max-width: 1199px), (hover: none) and (pointer: coarse)');
  const GAP = 8; // korunan öğeyle düğme arasındaki en az boşluk (px)
  const STEP = 6; // boş yer ararken yukarı adım (px)
  const MAX_RISE = 200; // en fazla bu kadar yukarı (px; kısa ekranda yüksekliğin %30'u) — daha uzağa yüzmez, saklanır
  const MAX_DROP = 12; // gerekirse bu kadar aşağı (alt kenara en az 8 px kalır)
  const IDLE_MS = 420; // kaydırma bitti sayılma süresi
  const OVERLAY_RE = /(^|\s)(menu-open|wt-select-opened|mm3-mega-open|[\w-]*overlay[\w-]*-on)(\s|$)/;
  const PROTECT = 'h1,h2,h3,h4,a,button,input,select,textarea,label,summary,[role="button"],[role="link"],[class*="price"],[tabindex]:not([tabindex="-1"])';
  const CONTROL = 'button,input,select,textarea,summary,label,[role="button"]';
  const TYPING = 'input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]),textarea,select,[contenteditable="true"]';
  const CSS = `
    [data-mm3-chat-nudge]{--mm3-chat-y:0px}
    :host([data-mm3-chat]) [data-mm3-chat-nudge]{transform:translate3d(0,calc(var(--mm3-chat-y) * -1),0);transition:transform .32s cubic-bezier(.2,.8,.2,1),opacity .2s ease,visibility 0s linear 0s}
    :host([data-mm3-chat~="away"]) [data-mm3-chat-nudge]{transform:translate3d(calc(100% + 28px),calc(var(--mm3-chat-y) * -1),0);opacity:0;visibility:hidden;pointer-events:none;transition:transform .26s cubic-bezier(.4,0,1,1),opacity .2s ease,visibility 0s linear .26s}
    :host([data-mm3-chat~="away"][data-mm3-chat~="left"]) [data-mm3-chat-nudge]{transform:translate3d(calc(-100% - 28px),calc(var(--mm3-chat-y) * -1),0)}
    @media (prefers-reduced-motion:reduce){
      :host([data-mm3-chat]) [data-mm3-chat-nudge]{transition:opacity .15s ease,visibility 0s linear 0s}
      :host([data-mm3-chat~="away"]) [data-mm3-chat-nudge]{transition:opacity .15s ease,visibility 0s linear .15s}
    }`;

  let outer = null; // sayfadaki <shopify-chat> (isabet testinde atlanır)
  let sr = null; // düğmenin bulunduğu shadow root
  let inner = null; // o kökün sahibi; durum öznitelikleri buna yazılır
  let btn = null;
  let nudge = null;
  let sheet = null;
  let styleEl = null;
  let side = 'right';
  let rise = 0;
  let away = false;
  let managed = false;
  let lastY = window.scrollY;
  let idleT = 0;
  let schedT = 0;
  let quickAt = 0;
  let retryT = 0;
  let retries = 0;
  let notBefore = 0; // çekmece kapanırken (~0.3 sn kayar) bu ana kadar ölçme
  let lastScrollAt = 0;
  let vvFull = 0; // klavye kapalıyken görünür alan yüksekliği
  const watched = new WeakSet();

  /* ---------- Inbox bileşenini bul ve bağla ---------- */
  // part="activator" düğmelerini iç içe açık shadow root'larda arar; görünür olanı tercih eder.
  function findActivator(root, depth, out) {
    root.querySelectorAll('[part~="activator"]').forEach((b) => out.push(b));
    if (depth < 3) root.querySelectorAll('*').forEach((e) => e.shadowRoot && findActivator(e.shadowRoot, depth + 1, out));
    return out;
  }

  function watch(root) {
    if (watched.has(root)) return;
    watched.add(root);
    new MutationObserver(onShadowChange).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-expanded'] });
  }

  function bind() {
    const h = document.querySelector('shopify-chat');
    if (!h || !h.shadowRoot) return false;
    watch(h.shadowRoot);
    const all = findActivator(h.shadowRoot, 0, []);
    const b = all.find((x) => x.offsetWidth > 0) || all[0];
    if (!b) return false;
    const root = b.getRootNode();
    if (root !== sr) {
      release(); // eski köke yazılmış durum kalmasın
      sr = root;
      inner = root.host;
      watch(root);
    }
    outer = h;
    btn = b;
    // taşınacak kutu: düğmeden yukarı ilk konumlandırılmış öğe (Inbox'ta .activator-nudge, right/bottom 20px)
    let n = b;
    while (n.parentElement && getComputedStyle(n).position === 'static') n = n.parentElement;
    if (n !== nudge) {
      if (nudge) nudge.removeAttribute('data-mm3-chat-nudge');
      nudge = n;
      nudge.setAttribute('data-mm3-chat-nudge', '');
    }
    ensureStyle();
    return true;
  }

  function ensureStyle() {
    try {
      if ('adoptedStyleSheets' in sr && typeof CSSStyleSheet === 'function' && 'replaceSync' in CSSStyleSheet.prototype) {
        if (!sheet) {
          sheet = new CSSStyleSheet();
          sheet.replaceSync(CSS);
        }
        if (!sr.adoptedStyleSheets.includes(sheet)) sr.adoptedStyleSheets = [...sr.adoptedStyleSheets, sheet];
        return;
      }
    } catch (e) {
      sheet = null; /* eski tarayıcı: <style> ile devam */
    }
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.textContent = CSS;
    }
    if (!sr.contains(styleEl)) {
      sr.appendChild(styleEl);
      setRiseVar();
    }
  }

  // Kaydırma miktarı kendi stil kuralımızda (Inbox satır içi stili yeniden yazsa da kaybolmaz).
  function setRiseVar() {
    const s = sheet || (styleEl && styleEl.sheet);
    const rule = s && s.cssRules[0];
    if (rule && rule.style) rule.style.setProperty('--mm3-chat-y', `${rise}px`);
  }

  function stale() {
    return !btn || !btn.isConnected || !nudge || !nudge.isConnected || btn.offsetWidth === 0;
  }

  function onShadowChange() {
    // Inbox düğmeyi yeniden çizdiyse / başka köke taşıdıysa yeniden bağla; sohbet açılıp kapandıysa yerini yeniden hesapla
    if (stale() && !bind()) return;
    schedule(60);
  }

  const chatOpen = () => btn && btn.getAttribute('aria-expanded') === 'true';

  /* ---------- durum ---------- */
  function apply(nextRise, nextAway) {
    rise = nextRise;
    // klavye / ekran okuyucu odağı düğmedeyse (Esc ile kapanınca Inbox odağı buraya iade eder) saklama;
    // dokunuş sonrası odak :focus-visible sayılmaz, orada normal kural sürer
    let kbdFocus = false;
    try {
      kbdFocus = sr.activeElement === btn && btn.matches(':focus-visible');
    } catch (e) {
      /* :focus-visible yoksa normal kural */
    }
    away = nextAway && !kbdFocus;
    managed = true;
    setRiseVar();
    inner.setAttribute('data-mm3-chat', `on${away ? ' away' : ''}${side === 'left' ? ' left' : ''}`);
  }

  function release() {
    if (!managed || !inner) return;
    managed = false;
    rise = 0;
    away = false;
    inner.removeAttribute('data-mm3-chat');
    setRiseVar();
  }

  /* ---------- geometri ---------- */
  // Düğmenin bizim kaydırmamız olmadan durduğu yer: ekrandaki kutudan o anki transform öteleme payı çıkarılır
  // (geçiş sürerken de doğru; Inbox düğmeyi hangi kökte, hangi kapsayıcıyla konumlarsa konumlasın).
  function baseRect() {
    const r = nudge.getBoundingClientRect();
    if (!r.width || !r.height) return null;
    const tf = getComputedStyle(nudge).transform;
    let dx = 0;
    let dy = 0;
    if (tf && tf !== 'none') {
      try {
        const m = new DOMMatrixReadOnly(tf);
        dx = m.m41;
        dy = m.m42;
      } catch (e) {
        return null;
      }
    }
    const l = r.left - dx;
    const t = r.top - dy;
    side = l + r.width / 2 < window.innerWidth / 2 ? 'left' : 'right';
    return { l, t, r: l + r.width, b: t + r.height };
  }

  function textRects(el, out) {
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
      acceptNode: (n) => (n.nodeValue.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT),
    });
    const range = document.createRange();
    let n;
    let count = 0;
    while ((n = walker.nextNode()) && count < 200) {
      count += 1;
      range.selectNodeContents(n);
      for (const r of range.getClientRects()) if (r.width && r.height) out.push(r);
    }
    return count;
  }

  function collect(el, out) {
    if (el.matches(CONTROL)) {
      const r = el.getBoundingClientRect();
      if (r.width && r.height) out.push(r);
      return;
    }
    if (textRects(el, out)) return;
    // metinsiz küçük ikon linki (ör. kalp) korunur; metinsiz büyük görsel linki (kart görseli) korunmaz
    const r = el.getBoundingClientRect();
    if (r.width && r.height && r.width < 80 && r.height < 80) out.push(r);
  }

  function protectedRects(band) {
    const seen = new Set();
    const out = [];
    const xs = [band.l + 3, (band.l + band.r) / 2, band.r - 3];
    for (let y = band.t; y <= band.b; y += 10) {
      for (const x of xs) {
        const list = document.elementsFromPoint(x, y);
        let used = 0;
        for (const e of list) {
          if (e === outer || e === document.body || e === document.documentElement) continue;
          if (used++ >= 6) break;
          const p = e.closest(PROTECT);
          if (!p || seen.has(p)) continue;
          seen.add(p);
          collect(p, out);
        }
      }
    }
    return out;
  }

  const hits = (a, c) => a.left < c.r && a.right > c.l && a.top < c.b && a.bottom > c.t;

  function clearAt(base, rects, r) {
    const c = { l: base.l - GAP, r: base.r + GAP, t: base.t - r - GAP, b: base.b - r + GAP };
    return !rects.some((a) => hits(a, c));
  }

  /* ---------- karar ---------- */
  function hiddenByContext() {
    const b = document.body;
    // çekmece / menü / arama açık; koleksiyondaki sıralama listesi gövdeye sınıf değil öznitelik yazar
    if (OVERLAY_RE.test(b.className) || b.hasAttribute('custom-select-opened')) return true;
    // yazı alanı odakta VE klavye görünür alanı gerçekten daraltmış (Android'de klavye kapanınca odak alanda kalabilir)
    const a = document.activeElement;
    const typing = Boolean(a && a !== b && a.matches && a.matches(TYPING));
    const vv = window.visualViewport;
    const h = vv ? vv.height * vv.scale : 0;
    if (!typing) {
      vvFull = h;
      return false;
    }
    return !vv || h < vvFull - 120;
  }

  // Tam yerleşim: en alttaki boş yeri bul (kaydırma durunca, sayfa değişince).
  function place() {
    if (stale() && !bind()) return;
    if (!MQ.matches || chatOpen()) return release();
    ensureStyle();
    if (hiddenByContext()) return apply(rise, true);
    const base = baseRect();
    if (!base) return release();
    const maxRise = Math.min(MAX_RISE, Math.round(window.innerHeight * 0.3));
    const maxDrop = Math.max(0, Math.min(MAX_DROP, window.innerHeight - base.b - 8));
    const band = { l: base.l - GAP, r: base.r + GAP, t: Math.max(0, base.t - maxRise - GAP), b: Math.min(window.innerHeight - 1, base.b + maxDrop + GAP) };
    const rects = protectedRects(band);
    // en yakın boş yer: 0, -6, +6, -12, +12, +18 … (eksi = aşağı)
    for (let d = 0; d <= maxRise; d += STEP) {
      if (d && d <= maxDrop && clearAt(base, rects, -d)) return settle(-d);
      if (clearAt(base, rects, d)) return settle(d);
    }
    apply(rise, true);
    // sayfa o an kayıyor olabilir (açılan çubuk, geç yüklenen görsel): kısa aralıkla en çok iki kez daha dene
    if (retries < 2) {
      retries += 1;
      clearTimeout(retryT);
      retryT = setTimeout(place, 700);
    }
  }

  function settle(r) {
    retries = 0;
    apply(r, false);
  }

  // Bulunduğu yerde korunan bir öğe var mı (yer aramadan; ucuz)
  function collidesNow() {
    const base = baseRect();
    if (!base) return false;
    const band = { l: base.l - GAP, r: base.r + GAP, t: base.t - rise - GAP, b: base.b - rise + GAP };
    return !clearAt(base, protectedRects(band), rise);
  }

  // Hızlı bakış (yukarı kaydırırken): bulunduğu yer boşsa görünür, değilse gizli; yer aramaz.
  function quick() {
    const now = performance.now();
    if (now - quickAt < 140 || now < notBefore) return; // çekmece kapanırken bekle
    quickAt = now;
    if (!MQ.matches || chatOpen() || hiddenByContext()) return;
    const base = baseRect();
    if (!base) return;
    const band = { l: base.l - GAP, r: base.r + GAP, t: base.t - rise - GAP, b: base.b - rise + GAP };
    apply(rise, !clearAt(base, protectedRects(band), rise));
  }

  function schedule(ms) {
    clearTimeout(schedT);
    schedT = setTimeout(() => {
      // kaydırma sürüyorsa bekle: boşta kalınca onScroll'un zamanlayıcısı yerleştirir
      if (performance.now() - lastScrollAt < IDLE_MS) return;
      place();
    }, Math.max(ms, notBefore - performance.now()));
  }

  /* ---------- olaylar ---------- */
  function onScroll() {
    if (!btn || !MQ.matches || chatOpen()) return;
    retries = 0;
    clearTimeout(retryT);
    const y = window.scrollY;
    const d = y - lastY;
    lastY = y;
    lastScrollAt = performance.now();
    if (d > 2 && y > 80) {
      if (!away) apply(rise, true);
    } else if (d < -2) {
      quick();
    }
    clearTimeout(idleT);
    idleT = setTimeout(place, IDLE_MS);
  }

  function start() {
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', () => schedule(150), { passive: true });
    if (window.visualViewport) window.visualViewport.addEventListener('resize', () => schedule(150), { passive: true });
    document.addEventListener('focusin', () => schedule(30));
    document.addEventListener('focusout', () => schedule(250));
    document.addEventListener('click', () => schedule(380), true);
    // çekmece açılınca hemen gizle; kapanınca kayma animasyonu bitene kadar ölçme
    const overlayOn = () => OVERLAY_RE.test(document.body.className) || document.body.hasAttribute('custom-select-opened');
    let ctxOn = overlayOn();
    new MutationObserver(() => {
      const on = overlayOn();
      if (ctxOn && !on) notBefore = performance.now() + 380;
      ctxOn = on;
      schedule(60);
    }).observe(document.body, { attributes: true, attributeFilter: ['class', 'custom-select-opened'] });
    // ürün sayfasının sabit "Add to bag" çubuğu açılıp kapanınca (kayma animasyonu bitince) yeniden yerleş
    document.querySelectorAll('sticky-buy-button, .wt-product__sticky-buy').forEach((el) => {
      new MutationObserver(() => schedule(360)).observe(el, { attributes: true, attributeFilter: ['class'] });
    });
    if ('ResizeObserver' in window) new ResizeObserver(() => schedule(200)).observe(document.body);
    const onMQ = () => schedule(0);
    if (MQ.addEventListener) MQ.addEventListener('change', onMQ);
    else if (MQ.addListener) MQ.addListener(onMQ);
    // Inbox düğmeyi iç içe köke taşıdığında yeni kök henüz izlenmiyor olabilir: düğme koptuysa / gizlendiyse yeniden bağla
    // Kendi kendini düzeltme: sayfa dururken düzen değiştiyse (yazı tipi geç yüklendi, akordeon açıldı, görsel geldi)
    // düğmenin altına korunan bir öğe girmiş olabilir; gizliyken de boş yer açılmış olabilir.
    setInterval(() => {
      if (!MQ.matches || document.hidden) return;
      if (stale()) {
        if (bind()) schedule(60);
        return;
      }
      if (!managed || chatOpen() || performance.now() - lastScrollAt < IDLE_MS) return;
      if (away ? !hiddenByContext() : collidesNow()) place();
    }, 1500);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => schedule(120));
    window.addEventListener('load', () => schedule(120));
    place();
  }

  // Inbox betiği geç yüklenir: bileşen ve düğme görünene kadar bekle (en çok ~60 sn).
  if (bind()) {
    start();
  } else {
    let tries = 0;
    const mo = new MutationObserver(() => {
      if (bind()) {
        mo.disconnect();
        clearInterval(timer);
        start();
      }
    });
    mo.observe(document.body, { childList: true });
    const timer = setInterval(() => {
      tries += 1;
      if (bind()) {
        mo.disconnect();
        clearInterval(timer);
        start();
      } else if (tries > 120) {
        mo.disconnect();
        clearInterval(timer);
      }
    }, 500);
  }
})();
